import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { OrderDetailList } from './OrderDetail.List';
import { OrderDetailCreate } from './OrderDetail.Create';
import { OrderDetailEdit } from './OrderDetail.Edit';

export default {
    list: OrderDetailList,
    create: OrderDetailCreate,
    edit: OrderDetailEdit,
    icon: ReceiptLongIcon,
};
